<template>
  <div>
    <div v-if="showLoading" class="loadingComponent-loading-position">
      <v-progress-circular 
        :size="70" 
        :width="7" 
        color="white" 
        indeterminate>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLoading: Boolean
  }
};
</script>
